import Quill from 'quill'

const Module = Quill.import('core/module')
const Parchment = Quill.import('parchment')
const ImageBlot = Quill.import('formats/image')
const VideoBlot = Quill.import('formats/video')

class EmbedSelect extends Module {
	constructor (quill, options) {
		super(quill, options)

		quill.root.addEventListener('click',
			this.handleClicks.bind(this)
		)

		quill.on('selection-change',
			this.handleSelection.bind(this)
		)
	}

	handleClicks ({ target }) {
		let embed = Parchment.find(target)

		if (embed instanceof ImageBlot || embed instanceof VideoBlot) {
			let offset = embed.offset(this.quill.scroll)
			this.quill.setSelection(offset, 1)
		}
	}

	get selectedEmbeds () {
		return this.quill.root.querySelectorAll(`.${this.constructor.className}`)
	}

	handleSelection (range) {
		if (!range) return
		const [blot] = this.quill.getLeaf(range.index)

		this.selectedEmbeds.forEach((elem) => {
			elem.classList.remove(this.constructor.className)
		})

		if (blot.domNode.classList) {
			blot.domNode.classList.add(this.constructor.className)
		}
	}
}

EmbedSelect.className = 'is-selected'
export default EmbedSelect
